import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useForm } from 'react-hook-form';
import RoutesApp from '../../routes';

//Servicios

//Modelos

//Componentes
import Spinner from '../../components/spinner/Spinner';
import NewDJCV from './NewDJCV';

function NewDJCVContainer() {
    const { toast, token, grapesVariety } = useGlobalContext();
    const Navigate = useNavigate();
    const Params = useParams();

    const [loader, setLoader] = useState(false);
    const [DJCVData, setDJCVData] = useState();

    const FormMethods = useForm();

    useEffect(() => {
        // async function fetchDJCV() {
        //     try {
        //         setLoader(true);
        //         //Obtenemos la DJCV segun el id de los params
        //         const DJCV = await DJCPService.single({
        //             token,
        //             id: parseInt(Params.id),
        //         });
        //         if (DJCV) {
        //             //Establecemos los datos para la nueva DJCV
        //             const newDJCV = new NewDJCPModel({
        //                 cabecera: DJCV.data.cabecera,
        //                 items: DJCV.data.items,
        //             });
        //             setDJCVData(newDJCV);
        //             setTableData(buildTableData(newDJCV.items));
        //             //Establecemos los valores iniciales del form
        //             let formValues = {};
        //             DJCV.data.items.forEach((it, i) => {
        //                 formValues[`kilos` + i] = it.kilos;
        //             });
        //             FormMethods.reset(formValues);
        //         }
        //         setLoader(false);
        //     } catch (err) {
        //         setLoader(false);
        //         return err;
        //     }
        // }
        // fetchDJCV();
    }, []);

    const onSubmit = async (data) => {
        try {
            setLoader(true);
            //Formacion del objeto para enviar en la peticion
            let formItems = { ...DJCVData };
            formItems.items.forEach((it, i) => {
                it.kilos = parseInt(data[`kilos` + i]);
            });

            //Peticion para actualizar la DJCV
            // const UpdateDJCTV = await DJCPService.update({
            //     token,
            //     declaracion: formItems,
            // });

            // //Si la respuesta es correcta, navegamos denuevo a la tabla de DJCPs y desplegamos mensaje de éxito
            // if (UpdateDJCTV) {
            //     Navigate(RoutesApp.Declaraciones.transferenciaViniedo);
            //     toast('DJCV enviada con éxito', { type: 'success' });
            // }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            console.log(err);
            return err;
        }
    };

    /**Funcion que crea el objeto para pasarle a la tabla que lista las DJCPs */
    const buildTableData = (
        data = [
            { id: 0, variedad: 0, superficie: 0, kilos: 0, id_declaracion: 0 },
        ]
    ) => {
        return {
            headers: ['Variedad de Uva', 'Superficie', 'Kilos Probables'],
            pagination: 10,
            data: data?.map((dj, i) => {
                return {
                    variedad: grapesVariety?.find(
                        (gv) => gv.codigo === dj.variedad
                    )?.variedad,
                    superficie: `${dj.superficie} m²`,
                    kilos: (
                        <input
                            {...FormMethods.register('kilos' + i)}
                            type={'number'}
                        />
                    ),
                };
            }),
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    return loader ? (
        <Spinner />
    ) : (
        <NewDJCV
            functions={{
                ...FormMethods,
                onSubmit,
            }}
            states={{ tableData, DJCVData }}
        />
    );
}

export default NewDJCVContainer;
